import * as log from 'loglevel';
import * as _ from "lodash"
import * as ko from 'knockout';
import {ComputedOptions} from "~knockout/index";
import {getPrimaryScreenVisibilityOptions} from "../ScreenVisibility";
import {Screen} from "../Screen";
import {showPrimaryScreen, showSecondaryScreen} from "../ScreenManager";
import {Observable} from '~knockout/index';
import {getGameManager} from '../../game/GameManager';
import {game} from '../../game/GameCore';

var template = require('./OrientationWarningScreen.html');

class OrientationWarningScreenComponent
{
    public visible: Observable<boolean>;

    constructor()
    {
        //  add bindings

        this.createBindings();

        //  add listeners

        this.addListeners();

        //  set initial visibility

        this.checkWindowSize();
    }

    /**
     * create knockout bindings
     */
    createBindings()
    {
        this.visible = ko.observable(false);
    }


    /**
     * listen to window resize events
     */
    addListeners()
    {
        window.addEventListener('resize', () => this.checkWindowSize());
    }


    /**
     * assess the current size/orientation of the browser window
     */
    checkWindowSize()
    {
        //  if the window is portrait, show the device orientation warning

        this.visible(window.innerWidth < window.innerHeight);

        //  pause or resume the game depending on the result

        //this.visible ? getGameManager().pauseGame() : getGameManager().resumeGame();

        //if (this.visible())
        //{
        //    //  pause the game when we resize
        //
        //    game.paused = true;
        //
        //    //  show the pause menu
        //
        //    showSecondaryScreen('pause');
        //}
        //else
        //{
        //
        //}
    }
}


/**
 * register this component with knockout
 * @param vizID
 */
export function registerOrientationWarningScreenComponent()
{
    ko.components.register('pp-orientation-warning',
        {
            viewModel: () => { return new OrientationWarningScreenComponent() },
            template: template
        });
}


// WEBPACK FOOTER //
// ./src/ts/screens/device-orientation-warning/OrientationWarningScreen.ts